import { Box, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  title: string;
  description: string;
  icon: string;
}

const GamificationCardHeader = ({ title, description, icon }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Box sx={styles.logo}>
        <Box
          component="i"
          className={icon}
          sx={{ color: "white", fontSize: 20 }}
        />
      </Box>
      <Box>
        <Typography variant="h5" fontWeight={700} lineHeight={1.2}>
          {title}
        </Typography>
        <Typography color="text.secondary">{description}</Typography>
      </Box>
    </Box>
  );
};

export default GamificationCardHeader;
